import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {SplitService} from "../../../commons/services/split-service.service";

export class preferencesValueReadCtrl implements IController {

  property: any;

  public propertyCopy: any;
  public siteProgramTypesMap: any;

  /* @ngInject */
  constructor(private splitService: SplitService) {
  }

  $onInit() {
    this.propertyCopy = angular.copy(this.property);

    if (_.isUndefined(this.propertyCopy?.value)) {
      this.propertyCopy.value = this.property.defaultValue;
    }

    // Checks if value type Accessorial is string and parse it.
    if (this.propertyCopy.valueType === 'Accessorial') {
      this.propertyCopy.value = JSON.parse(this.propertyCopy.value);
      return;
    }

    if (!!this.propertyCopy.value &&
      (this.property.valueType === 'Boolean' ||
        this.property.valueType === 'MultiSelect' ||
        this.property.valueType === 'DateRange' ||
        this.property.valueType === 'DayTime' ||
        this.property.valueType === 'OptionsList')) {
      this.propertyCopy.value = JSON.parse(this.propertyCopy.value);
    }

    if (this.propertyCopy.dataUnit === 'Percent') {
      this.propertyCopy.value = this.propertyCopy.value ? JSON.parse(this.propertyCopy.value) * 100 : undefined;
    }

    // Checks if Date value is string and parse it.
    if (this.property.valueType === 'Date' && this.property.value) {
      const validationTest = this.property.value.search('/');
      const validationTestDash = this.property.value.search('-');

      if (_.isEqual(validationTest, -1) && _.isEqual(validationTestDash, -1)) {
        this.propertyCopy.value = JSON.parse(this.property.value);
      } else {
        this.propertyCopy.value = new Date();
      }
    }

    if (this.property.valueType === 'PricePlanProgramType' && this.property.value) {
      this.siteProgramTypesMap = this.splitService.getSiteProgramTypesMap();
    }

  };

  $onChanges(changes) {
    if (changes.property && !changes.property.isFirstChange()) {
      this.$onInit();
    }
  }

}

angular
  .module('bringoz.admin.site-preferences')
  .component('preferencesValueRead', {
    bindings: {
      property: '<'
    },
    template: require('./preferences-value-read.html').default,
    controller: preferencesValueReadCtrl
  });
